import { Component, Input, OnInit } from '@angular/core'
import { LaunchDialogService } from '@spartacus/storefront'
import { filter, take } from 'rxjs/operators'
import { DialogResponse, VS_LAUNCH_CALLER } from '../../../config/dialog.config'

@Component({
  standalone: false,

  selector: 'vs-empty-cart',
  templateUrl: './empty-cart.component.html',
  styleUrls: ['./empty-cart.component.scss'],
})
export class EmptyCartComponent implements OnInit {
  @Input() nonSellableProd: any[]
  productFlag: any
  constructor(private launchDialogService: LaunchDialogService) {}

  ngOnInit(): void {
    this.productFlag = sessionStorage.getItem('nonSellableProd')
    if (
      this.nonSellableProd?.length > 0 &&
      (this.productFlag == 'true' || this.productFlag == true)
    )
      this.openNonSellableDialog()
  }
  openNonSellableDialog() {
    const componentdata = {
      nonSellableProducts: this.nonSellableProd,
    }

    const nonSellableDialog = this.launchDialogService.openDialog(
      VS_LAUNCH_CALLER.NON_SELLABLE,
      undefined,
      undefined,
      componentdata
    )
    if (nonSellableDialog) {
      nonSellableDialog.pipe(take(1)).subscribe((value) => {})
      this.launchDialogService.dialogClose
        .pipe(
          filter(
            (dialogResponse: DialogResponse) =>
              dialogResponse?.type == VS_LAUNCH_CALLER.NON_SELLABLE
          ),
          take(1)
        )
        .subscribe((value) => {
          if (value.reason == 'ok-non-sellable')
            sessionStorage.setItem('nonSellableProd', 'false')
        })
    }
  }
}
